 <template>
	<div>
		<a-table rowKey="id" :columns="columns" :data-source="data" size="small" :pagination="false">
			<template slot="ope" slot-scope="row">
				<a href="#" class="fs13 mr10" @click="edit(row)" >编辑</a>
				<a href="#" class="fs13 mr10" @click="bank_message(row)"  >银行账号</a>
				<a-modal v-model="visibleBank" title="银行账户信息" @cancel="visibleBank=false" :footer="null">
					<p>单位名字：{{ ((bank_detail.invoice_title != "")&&(bank_detail.invoice_title != null))?bank_detail.invoice_title:"--" }}</p>
					<p>行号：{{ ((bank_detail.bank_code != "")&&(bank_detail.bank_code != null))?bank_detail.bank_code:"--" }}</p>
					<p>开户行：{{ ((bank_detail.opening_bank != "")&&(bank_detail.opening_bank != null))?bank_detail.opening_bank:"--" }}</p>
					<p>账号：{{ ((bank_detail.bank_account != "")&&(bank_detail.bank_account != null))?bank_detail.bank_account:"--" }}</p>
				</a-modal>
				<a href="#" class="fs13 mr10" @click="uploadBankOrder(row)">打款</a>

				<a-modal 
					v-model="visibleBankOrder" 
					title="上传银行回单" 
					@ok="comfirmUpload()"
					@cancel="visibleBankOrder=false" 
					cancelText="取消" 
					okText="确定"
				>
					<a-upload
						:action="upload_url"
						name="file"
						:multiple="true"
						:headers="headers"
						@change="handleChange"
					>
						<a-button> <a-icon type="upload" /> 点击上传银行回单 </a-button>
					</a-upload>
				</a-modal>
				<!-- <a-popconfirm
					ok-text="是"
					cancel-text="否"
					@confirm="confirm(row)"
				>
					<template #title>
						<a-checkbox v-model:checked="form.checked" v-if="row.status == 12">
							已打全款
						</a-checkbox>
						<p v-else>确认打款？</p>
					</template>
					<a href="#" class="fs13">打款</a>
				</a-popconfirm> -->
			</template>
		</a-table>
		<a-modal
			title="更改固定资产"
			:visible="visible"
			@ok="handleOk"
			okText="确定"
			cancelText="取消"
			@cancel="visible=false"
		>	
			<div class="flex items-center">
				<div class="fs15">请选择是否为固定资产：</div>
				<a-select v-model:value="invData.is_fixed_assets" style="width: 120px">
					<a-select-option value="1">
						是
					</a-select-option>
					<a-select-option value="0">
						否
					</a-select-option>
				</a-select>
			</div>
		</a-modal>
	</div>
</template>

<script>
    import { message } from 'ant-design-vue';
	export default ({
		data() {
			return {
				columns: [
                    // { title: '编号', fixed: 'left', scopedSlots: { customRender: 'id' }, width: 180 },
                    { title: '采购物资', dataIndex: 'name' },
                    { title: '品牌', dataIndex: 'brand' },
                    { title: '规格', dataIndex: 'model' },
                    { title: '物资申购日期', dataIndex: 'create_time' },
                    { title: '申请打款时间', dataIndex: 'process_time' },
                    { title: '计划入场日期', dataIndex: 'due_date' },
                    { title: '数量', dataIndex: 'count' },
                    { title: '单价（不含税）', dataIndex: 'show_price_without_tax' },
                    { title: '单价（含税）', dataIndex: 'show_price_with_tax' },
                    { title: '总价', dataIndex: 'show_total_price' },
                    { title: '定金', dataIndex: 'show_deposit' },
                    { title: '尾款', dataIndex: 'show_balance' },
                    { title: '状态', dataIndex: 'status_name' },
                    { title: '是否固定资产', dataIndex: 'fixed_assets' },
                    { title: '操作', scopedSlots: { customRender: 'ope' } },
                ],
				data: [],
				form: {
					checked: false
				},
				visible:false,
				visibleBank:false,
				visibleBankOrder:false,
				bank_detail:{},
				invData:{},
				upload_url: "",
				headers: {},
				attachemnt:[],
			}
		},
		created() {
			this.upload_url = this.$api.request_body.url + "/project/upload_assets";
			this.headers.token = this.$api.request_body.token;
			this.getFinancialPayment();
		},
		methods: {
			async getFinancialPayment() {
				let rs = await this.$api.getFinancialPayment();
				console.log(rs.data)
				if (rs.err == 0) {
					for (let item of rs.data) {
						if (item.process_time != null) {
							item.process_time = item.process_time.replace("T", " ");
						}
						item.create_time = item.create_time.substring(0, item.create_time.indexOf("T"))
						item.show_price_without_tax = (item.price_without_tax/100).toFixed(2) + "元";
						item.show_price_with_tax = (item.price_with_tax/100).toFixed(2) + "元";
						item.total_price = item.price_with_tax * item.count;
						item.amount = item.total_price
						item.show_total_price = (item.total_price/100).toFixed(2) + "元";
						if (item.deposit != null && item.deposit != 0) {
							item.show_deposit = (item.deposit / 100).toFixed(2) + "元";
							item.show_balance = ((item.total_price - item.deposit) / 100).toFixed(2) + "元";
						} else {
							item.show_deposit = "无";
							item.show_balance = "无";
						}
						if(!item.opening_bank){
                            item.opening_bank = ""
                        }
                        if(!item.bank_account){
                            item.bank_account = ""
                        }
						item.fixed_assets = (item.is_fixed_assets == 1)?"是":"否"
					}
					this.data = rs.data;
				}
			},
			async confirm(item) {
				let rs = await this.$api.confirmPayment(item.id, this.form.checked);
				if (rs.err == 0) {
					this.getFinancialPayment();
				}
				this.form.checked = false;
			},
			edit(row){
				this.invData = row
				this.visible = true
				console.log(row)
			},
			bank_message(row){
				console.log(row)
				this.bank_detail = row
				this.bank_detail.attachment = []
				this.visibleBank = true
			},
			uploadBankOrder(row){
				this.bank_detail = row
				this.bank_detail.attachment = []
				this.visibleBankOrder = true
			},
			async handleOk(){
				console.log(this.invData)
                let rs = await this.$api.updateTicketMaterialFixedAssets(this.invData.id, this.invData.is_fixed_assets);
				if (rs.err == 0) {
                    message.success("保存成功")
                } else {
                    message.error("保存失败，请联系管理员")
                }
				this.visible = false
				this.getFinancialPayment()
			},
			handleChange(info) {
				const status = info.file.status;
				if (info.file.status === 'uploading') {
					this.uploading = true;
					return;
				}
				if (status !== 'uploading') {
				}
				if (status === 'done') {
					if (info.file.response.err == 0) {
                        this.bank_detail.attachemnt = []
                        for(let part of info.fileList){
                            this.bank_detail.attachemnt.push(part.response.data);
                        }
						this.$message.success(`${info.file.name} 上传成功`);
					} else {
						this.$message.error(`${info.file.name} 上传失败`);
					}
					this.uploading = false
				} else if (status === 'error') {

				}
			},
			async comfirmUpload(){
                let rs = await this.$api.goUploadBankOrder(this.bank_detail);
				if (rs.err == 0) {
					this.$message.success({ content: '正在保存中...', KF })
                    .then(() => {
						this.$message.success('保存成功', 2);
						this.visibleBankOrder = false;
						this.getFinancialPayment();
					})
				}else{
					this.$message.loading({ content: '正在保存中...', KF })
					.then(() => this.$message.warn('保存失败，请检查后重试或联系管理员', 2))
				}
			}
		}
	})

</script>

<style lang="scss">
</style>